// Imports Angular
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

// Imports Aplicacion
import { DContextoMuisca, DServicio, DRespuestaSimple  } from '@dian/core';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DListaDocumentos, DInfoResumenFormulario } from '@dian/api-formulario';
import { DGratuidadGenericoServicios } from '@dian-api/gratuidad-generico';
import { RecaptchaComponent } from './../../resources/components/recaptcha/recaptcha.component';
import { DFormato, AnioLink } from './../../to/dformato';
import { FiltroFormatosPipe } from './../../pipes/filtro-formatos.pipe';
import { MessageService } from './../../resources/services/message.service';
import { isFunction } from 'util';


export interface ResponseDialogAnio {
  modelo: DFormato,
  anio: AnioLink,
  redireccionar: string,
  ultimoAnio: boolean
  

}

@Component({
  moduleId: module.id,
  selector: 'c',    
  templateUrl: 'selector.component.html',
  styleUrls: ['selector.component.css'],
  providers: [
    DNotificacionServicio,
    DServicio,
    FiltroFormatosPipe,
    DGratuidadGenericoServicios
  ]
})

export class SelectorComponent implements OnInit {

    public busqueda = null; 
    public datosContexto: DContextoMuisca;  
    public documentoConsulta: string;
    public tipoDocumento: string;       
    public dFormatosDiligenciamiento: DFormato[];
    public pathAssetsFormatos: string;
    public hayElementosTributarios: boolean = true;
    public hayElementosAduaneros: boolean = true;
    public selectedTab: number = 0;

    private requiereRecaptcha: boolean = false;
    
    constructor(
        private router: Router,
        private dialog: MatDialog,
        private dNotificaciones: DNotificacionServicio,
        private dNotificacionServicio: DNotificacionServicio,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private dServicioCore: DServicio,
        private http: Http,    
        private _pipeFilter: FiltroFormatosPipe,   
        private _messageObservable: MessageService,
        private _restGratuidad: DGratuidadGenericoServicios
    ) {
        this.pathAssetsFormatos = './assets/data/'; 
        this.dFormatosDiligenciamiento = new Array<DFormato>();
    }

    ngOnInit() 
    {
      /* setTimeout(()=>{                          
        this.dNotificacionServicio.mostrarDialogoInformacion(`<p><strong>Señor contribuyente:</strong></p>
        <p>&nbsp;</p>
        <p> <strong>Cumpla su obligación de una manera ágil, sencilla y segura, diligencie su declaración, haciendo uso de nuestro Servicio Informático de Diligenciamiento.
        Cree su contraseña de usuario y podrá realizar múltiples actuaciones ante la DIAN”.
        <a href="https://muisca.dian.gov.co/WebArquitectura/DefNuevosUsuarios.faces"target="_blank">Habilitar cuenta.</a></strong></p>
                
        <p><strong> Sr, Contribuyente y usuario aduanero recuerde que en este servicio solamente están disponibles los formatos desde la vigencia 2014 y no se podrá diligenciar el pago del Régimen Simple de Tributación, este concepto deberá generarlo con su cuenta de usuario registrado.</strong></p>`);
      }, 1000); */

      setTimeout(() => this.consultarDatosContexto(), 50);      
    }
   
    private openRecaptchaDialogValidate(model: ResponseDialogAnio) {
      let dialogRef = this.dialog.open(RecaptchaComponent, {
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          let notificacion = this.dNotificaciones.mostrarDialogoInformacion('Señor contribuyente el captcha debe ser validado.');      
          notificacion.afterClosed().subscribe(() => this.openRecaptchaDialogValidate(model));
          return;
        }   
     
  
        //Logica de recaptcha valido
        if (model.ultimoAnio) {
          const fechaActual = new Date();
          const ultimoAnio = fechaActual.getFullYear();
          this.downloadPDFDocument(model.modelo.ideFormato, ultimoAnio, result.token);
        } else
          this.downloadPDFDocument(model.modelo.ideFormato, model.anio.anio, result.token);
      });   
    } 

    public emitEvent(event: string) {
      this._messageObservable.sendMessage(event);
    }

    
    /**
    * @desc Funcion que obtiene los datos del contexto para conocer el nit del contribuyente
    */
    private consultarDatosContexto() {
      this.obtenerFormatos();
      /*let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
      observableServicio.subscribe(
        res => {              
          this.datosContexto = <DContextoMuisca>res; 
          this.documentoConsulta = this.datosContexto.ANombrePropio ? this.datosContexto.NitUsuario : this.datosContexto.NitOrganizacion;
          this.tipoDocumento = this.datosContexto.ANombrePropio ? 'CC-' : 'NIT-';
          this.obtenerFormatos();
        }
      );*/    
    }
    
    

    /**
    * @desc Function para obtener la configuración de los formatos que incluye las rutas a las imagenes
    */
    private obtenerFormatos() {
      let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
      let serviceTributarios = this.http.get(`${this.pathAssetsFormatos}forms-tributarios.json`);
      let serviceAduaneros = this.http.get(`${this.pathAssetsFormatos}forms-aduaneros.json`);

      Observable
        .forkJoin([serviceTributarios, serviceAduaneros])        
        .map((result) => {
          for (let i in result) {
            result[i] = result[i].json();
          } 
          return result;
        })
        .subscribe(
          res => {        
            for (let i in res) {              
              for (let j in res[i]) {
                this.dFormatosDiligenciamiento.push(<DFormato>res[i][j]);
              }
            }
            precargaProceso.close();
          }
        );         
    }    

    /** 
     * Funcion para redireccionar segun el formulario
     * @param {ResponseDialogAnio} model
     */
    public redireccionar(model: ResponseDialogAnio) {
      if (model.redireccionar) 
        window.location.href = window.location.origin + model.redireccionar;
      if (!model || !model.anio) return;
      if (model.anio.link)
        window.location.href = window.location.origin + model.anio.link;
      else{
        if(model.anio.anio >= 2021 && model.modelo.ideFormato==210){
          this.dNotificacionServicio.mostrarDialogoInformacion(`<p><strong>Apreciado Contribuyente:</strong></p>
          <p>&nbsp;</p>
          <p>Con el propósito de facilitarte la presentación de tu <strong>Declaración de Renta y Complementarios Personas Naturales y Asimiladas de Residentes y Sucesiones Ilíquidas de Causantes Residentes,</strong> 
          te informamos que a partir del <strong>año gravable 2021,</strong> el diligenciamiento del <strong>Formulario 210</strong> se hará <strong>UNICAMENTE</strong> por la opción <strong><a href="${window.location.origin}" target="_blank">Usuarios Registrados.</a></strong>
          
          <p>Si aún no estás registrado, aprende <strong><a href="https://www.dian.gov.co/Prensa/Aprendelo-en-un-DIAN-X3/Paginas/Portal-Transaccional-DIAN.aspx" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">aquí</a></strong> como registrarte en un DIANX3. </p>`);
        
        }else{
          this.openRecaptchaDialogValidate(model); 
        }
        
      }
             
    }  

    /**
     * Funcion que realiza la busqueda de un formato para seleccionar la tab automaticamente
     */
    public obtenerGrupoFormatoBuscado() {
      let arr = this._pipeFilter.transform(this.dFormatosDiligenciamiento, this.busqueda);
      if (arr.length) {
        switch (arr[0].ideGrupo) {
          case 12960001: //Aduaneros
            this.selectedTab = 2;
            break;          
          case 12960003: //Tributarios
            this.selectedTab = 0;
            break;
        }
      }     
    }

    private downloadPDFDocument(ideFormato: number, anio: number, token: string) {      
      let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
      this._restGratuidad.descargarFormulario(ideFormato, anio, token)
        .subscribe(
          res => {
            const dinfodescarga: DRespuestaSimple = <DRespuestaSimple>res;
            const mediaType = 'application/pdf';
            const blob = new Blob([dinfodescarga.blob], {type: mediaType});
            const filename = `${ideFormato}-${anio}.pdf`;                            
            window['saveAs'](blob, filename);   
            precargaProceso.close();
          },
          error => {
            precargaProceso.close();
            this.dNotificaciones.mostrarDialogoError('Ocurrió un error generando el documento.');      
          }
        );
    }

}



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/components/selector/selector.component.ts